import { useEffect, useState } from 'react';

import GlobalLoader from '@apigrowfinance/pbolt-global-loader';
// eslint-disable-next-line import/no-unresolved
import { Auth } from 'auth/services/Auth';

import App from './App';

const auth = Auth.getInstance();

const DevApp = ({ basename }: { basename: string }) => {
    const [authInitialised, setAuthInitialised] = useState(false);

    useEffect(() => {
        auth.initialize().then(() => {
            setAuthInitialised(true);
        });
    }, []);

    return (
        <>{authInitialised ? <App basename={basename} /> : <GlobalLoader />}</>
    );
};

export default DevApp;
